import React from "react";

export default function MoonIcon() {
   return (
      <svg
         xmlns="http://www.w3.org/2000/svg"
         viewBox="0 0 256 256"
         stroke="#fff"
         strokeWidth={5}
      >
         <path
            fill="#fff"
            d="M233.54 142.23a8 8 0 0 0-8-2a88.08 88.08 0 0 1-109.8-109.8a8 8 0 0 0-10-10a104.84 104.84 0 0 0-52.91 37A104 104 0 0 0 136 224a103.09 103.09 0 0 0 62.52-20.88a104.84 104.84 0 0 0 37-52.91a8 8 0 0 0-1.98-7.98m-44.64 48.11A88 88 0 0 1 65.66 67.11a89 89 0 0 1 31.4-26A106 106 0 0 0 96 56a104.11 104.11 0 0 0 104 104a106 106 0 0 0 14.92-1.06a89 89 0 0 1-26.02 31.4"
         ></path>
      </svg>
   );
}
